import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['carousel'];

  connect() {
    // var c = bulmaCarousel.attach(this.carouselTarget, {
    //   slidesToScroll: 1,
    //   slidesToShow: 5,
    //   navigationSwipe: true,
    //   autoplay: true,
    //   loop: true,
    //   autoplaySpeed: 5000,
    //   breakpoints: [
    //     { changePoint: 600, slidesToShow: 1, slidesToScroll: 1 },
    //     { changePoint: 800, slidesToShow: 2, slidesToScroll: 1 },
    //     { changePoint: 1100, slidesToShow: 3, slidesToScroll: 1 },
    //     { changePoint: 1300, slidesToShow: 4, slidesToScroll: 1 },
    //     { changePoint: 2000, slidesToShow: 5, slidesToScroll: 1 }
    //   ]
    // });

    document.querySelector('.slider-navigation-previous').innerHTML = '<i class="fa fa-2x fa-chevron-left"></i>';
    document.querySelector('.slider-navigation-next').innerHTML = '<i class="fa fa-2x fa-chevron-right"></i>';
    document.querySelector('.slider-container').style.transform = 'translate3d(0, 0, 0)';
    // window.setTimeout(
    //   function () {
    //     window.setInterval(function () {
    //       if (c[0].state.index == 0) {
    //         c[0].stop();
    //         document.querySelector('.slider-container').style.transform = 'translate3d(0, 0, 0)';
    //       }
    //     }, 10);
    //   }, 7500)
  }


}
